<template>
  <v-container fluid>
    <v-row>
      <v-col flex>
        <v-card v-if="student" class="mx-auto" max-width="600" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">{{ student.school }}</div>
              <v-list-item-title class="headline mb-1">
                {{ student.first_name }} {{ student.last_name }} ({{
                  student.student_number
                }})
              </v-list-item-title>
              <v-list-item-subtitle v-if="student.program">{{
                student.program.name
              }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
              tile
              size="80"
              color="grey"
            ></v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn outlined rounded text> Modifier </v-btn>
          </v-card-actions>
        </v-card>
        <v-tabs
          v-model="tab"
          centered
          center-active
          grow
          show-arrows
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab key="0">
            ADRESSES
            <v-icon>mdi-map-marker</v-icon>
          </v-tab>
          <v-tab key="1">
            OBJECTIF PEDAGOGIQUES
            <v-icon>mdi-format-list-numbered</v-icon>
          </v-tab>
          <v-tab key="2">
            NOTES
            <v-icon>mdi-numeric</v-icon>
          </v-tab>
          <v-tab key="3">
            EVENEMENTS
            <v-icon>mdi-calendar-alert</v-icon>
          </v-tab>
          <v-tab key="4">
            JURY
            <v-icon>mdi-account-multiple</v-icon>
          </v-tab>
          <v-tab key="5">
            ABSENCES
            <v-icon>mdi-calendar-remove</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="0">
            <data-table-student-addresses></data-table-student-addresses>
          </v-tab-item>
          <v-tab-item key="1">
            <data-table-student-educational-objective></data-table-student-educational-objective>
          </v-tab-item>
          <v-tab-item key="2"> </v-tab-item>
          <v-tab-item key="3"> </v-tab-item>
          <v-tab-item key="4"> </v-tab-item>
          <v-tab-item key="5"> </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import  dataTableStudentEducationalObjective from './dataTableStudentEducationalObjective.vue'
import dataTableStudentAddresses from './dataTableStudentAddresses'


export default {
  name: "Student",
  components: {
    dataTableStudentEducationalObjective,
    dataTableStudentAddresses,
  },
  data: () => ({
    student: null,
    tab: 0,
  }),
  mounted() {
    this.axios
      .get("/student/" + this.$route.params.id)
      .then((response) => (this.student = response["data"]));
  },
};
</script>